import {signUpReducer} from '@modifi/website-client'
import pageReducer from './pages/reducer'

export default {
  signUp: signUpReducer,
  pages: pageReducer,
}
